module.exports = __webpack_public_path__ + "static/media/wechat.c1c1858b.svg";